import { CustomFieldsInformation } from '../types/CustomFieldsInformation';
import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';

export class CustomFieldsFormGzDataProvider extends BaseWebComponentDataProvider {
  public async getCustomFields(managedCompanyId: string): Promise<CustomFieldsInformation> {
    const customFields = await this.dependencies.api.clients.CustomFields.GetCustomFields(managedCompanyId).toPromise();

    if (!customFields) {
      throw new Error('No custom fields information data received');
    }

    return customFields;
  }
}
